export const appBaseURL = "/"

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"dns-prefetch","href":"https://fe-assets-cdn.youyan3d.com"},{"rel":"dns-prefetch","href":"https://official-site.youyan3d.com"},{"rel":"dns-prefetch","href":"https://official-site.youyan.xyz"},{"rel":"dns-prefetch","href":"https://media.youyan3d.com"},{"rel":"dns-prefetch","href":"https://media.youyan.xyz"}],"style":[],"script":[{"innerHTML":"\n      const query = new URLSearchParams(location.search);\n      let open_type = query.get('open_type') || '';\n      if (open_type) {\n        localStorage.setItem('youyan_open_type', open_type);\n      } else {\n        open_type = localStorage.getItem('youyan_open_type') || '';\n      }\n      console.log('youyan_open_type', open_type);\n      const is_iframe_env = window.top != window;\n      if (is_iframe_env && ['self', 'custom'].includes(open_type)) {\n        if (open_type == 'self') {\n          window.open = (url, target, features) => {\n            window.location.href = url;\n          };\n        }\n        if (open_type == 'custom') {\n          window.open = (url, target, features) => {\n            window.top.postMessage({\n              message_type: 'iframe_open',\n              url,\n              target,\n              features,\n              location: JSON.parse(JSON.stringify(location)),\n            });\n          };\n        }\n      }"},{"src":"https://lf1-cdn-tos.bytegoofy.com/goofy/lark/op/h5-js-sdk-1.5.42.js","defer":true}],"noscript":[],"charset":"utf-8","htmlAttrs":{"lang":"zh-CN"}}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false